import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import React, { useState, useEffect } from 'react'
import PortfolioItem from './PortfolioItem'
import * as images from '../../assets/images'

const portfolioData = [
  {
    src: [images.adhara1, images.adhara2],
    text: 'ADHARA is an Enterprise Integration System developed for ILCS (Pelindo Group). It focuses on integrating multiple microservices, surrounding systems, and inter-company applications across the Pelindo ecosystem. As a Backend Engineer, I implemented Go-based services to ensure reliable data exchange, transformation, and seamless interoperability within a distributed microservices architecture.',
    label: 'ADHARA (Pelindo)',
    link: 'https://www.adhara.id/',
  },
  {
    src: [images.komunal1, images.komunal2, images.komunal3, images.komunal4],
    text: 'Ki Komunal is a platform for the Directorate General of Intellectual Property (DJKI) to manage and protect Communal Intellectual Property in Indonesia. Built with React for the frontend and Laravel for the backend, it enables efficient management of traditional cultural expressions and geographical indications.',
    label: 'Ki Komunal DJKI',
    link: 'https://kikomunal-indonesia.dgip.go.id',
  },
  {
    src: [images.cerebrum1, images.cerebrum2, images.cerebrum3, images.cerebrum4, images.cerebrum5],
    text: 'Cerebrum is a comprehensive cognitive assessment and educational platform featuring scientifically-backed brain tests, interactive financial calculators (PPh 21, Vehicle Tax), and an integrated article system. Developed with SvelteKit and ElysiaJS, it includes a robust administrative dashboard for managing complex assessment items and real-time user data analysis.',
    label: 'Cerebrum',
    link: 'https://cerebrum.my.id',
  },
  {
    src: [images.lextica1, images.lextica2, images.lextica3],
    text: 'Lextica is a Legal AI Assistant platform featuring AI chat with RAG, document workspace management, and automated legal drafting. Built with FastAPI, Gemini 2.5 Flash, Qdrant Vector DB, and Celery, it enables intelligent legal research, document analysis, and professional drafting (NDA, MOU, etc.) with secure cloud storage.',
    label: 'Lextica',
    link: 'https://lextica.com',
  },
  {
    src: [images.bukumu1, images.bukumu2, images.bukumu3],
    text: 'Bukumu is an AI-powered Reading Companion designed for students to make reading academic and personal books more efficient and enjoyable. Built with SvelteKit and Elysia.js, it features AI summarization per chapter, smart text explanation, APA citation assistance, and a professional PDF/EPUB reader, along with an integrated manga/manhwa reader.',
    label: 'Bukumu',
    link: 'https://bukumu-app.my.id',
  },
  {
    src: [images.operational1, images.operational2, images.operational3, images.operational4, images.operational5, images.operational6, images.operational7, images.operational8],
    text: 'A Comprehensive Live Affiliate Management System for managing user hierarchy (Admin, Spv, Agent), device inventory, photo-based attendance, and bulk live reporting. Built with Bun, ElysiaJS, and Prisma (PostgreSQL), it automates payroll calculations and provides performance analytics for efficient business operations.',
    label: 'Operational System',
    link: 'https://operasional.site',
    objectFit: 'contain',
  },
  {
    src: [images.maxhealth, images.maxhealth2, images.maxhealth3, images.maxhealth4, images.maxhealth5],
    text: 'e-commerce for health and pharmacy, and dashboard for admin, pharmacy and doctor to sell a drug, or consultation about medical using live chat, for tech stack: fullstack using go as backend postgres as database and react as frontend',
    label: 'Maxhealth',
    link: 'https://max-health-frontend.vercel.app/',
  },
  {
    src: images.danoneVms,
    text: "danone's visitor management system application, for tech stack: fullstack using koa-js as backend mysql as database and react as frontend",
    label: 'VMS',
    link: 'https://vms-sn.id/home/',
  },
  {
    src: images.website5,
    label: 'Jobs Finder',
    link: 'https://jobsfinder.netlify.app/',
  },
  {
    src: images.weatherApp,
    label: 'Weather app',
    link: 'https://weather-app-react-lemon.vercel.app/',
  },
  {
    src: images.website2,
    label: 'Landing page Website Film',
    link: 'https://subtle-sawine-a430c1.netlify.app/',
  },
  {
    src: images.website1,
    label: 'Landing page Website e money',
    link: 'https://bank-website-react.vercel.app/',
  },
  {
    src: images.website3,
    label: 'Landing page Website Travelling',
    link: 'https://tour-website-react.vercel.app/',
  },
  {
    src: images.projectTictactoe,
    label: 'Tic tac toe',
    link: 'https://tictactoe123.vercel.app/',
  },
  {
    src: images.website4,
    label: 'Food order App',
    link: 'https://react-udemy-project11-food-order-app-advance.vercel.app/',
  },
  {
    src: images.kalkulator,
    label: 'Kalkulator App',
    link: 'https://kalkulator-dqv30404o-pratomosidiq123-gmailcom.vercel.app/',
  },
  {
    src: images.todoApp,
    label: 'Todo App',
    link: 'https://todo-hyka1lem2-pratomosidiq123-gmailcom.vercel.app/',
  },
]

function Portfolio() {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <div className="container portfolio-page">
      <h1 className="page-title">
        <AnimatedLetters
          strArray={['P', 'O', 'R', 'T', 'O', 'F', 'O', 'L', 'I', 'O']}
          idx={15}
          letterClass={letterClass}
        />
      </h1>
      <div id="tips-post-container">
        <div className="simple-bar-wrapper">
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div className="simplebar-offset">
              <div className="simplebar-content-wrapper">
                <div className="simplebar-content">
                  {portfolioData.map((item, idx) => (
                    <PortfolioItem
                      key={idx}
                      src={item.src}
                      text={item.text}
                      label={item.label}
                      link={item.link}
                      objectFit={item.objectFit}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Portfolio
